const getDefaultSetInterval = () =>
  typeof setInterval === 'function' ? setInterval : null;

const getDefaultClearInterval = () =>
  typeof clearInterval === 'function' ? clearInterval : null;

const getDefaultSetTimeout = () =>
  typeof setTimeout === 'function' ? setTimeout : null;

const getDefaultClearTimeout = () =>
  typeof clearTimeout === 'function' ? clearTimeout : null;

const getDefaultRequestAnimationFrame = () =>
  typeof requestAnimationFrame === 'function' ? requestAnimationFrame : null;

const getDefaultCancelAnimationFrame = () =>
  typeof cancelAnimationFrame === 'function' ? cancelAnimationFrame : null;

export const scheduleSafeTimeout = (
  callback,
  delay,
  setTimeoutFn = getDefaultSetTimeout()
) => {
  if (typeof callback !== 'function' || typeof setTimeoutFn !== 'function') {
    return null;
  }

  try {
    return setTimeoutFn(callback, delay);
  } catch (error) {
    return null;
  }
};

export const clearSafeTimeout = (
  timer = null,
  clearTimeoutFn = getDefaultClearTimeout()
) => {
  if (!timer || typeof clearTimeoutFn !== 'function') {
    return false;
  }

  try {
    clearTimeoutFn(timer);
    return true;
  } catch (error) {
    return false;
  }
};

export const scheduleSafeInterval = (
  callback,
  delay,
  setIntervalFn = getDefaultSetInterval()
) => {
  if (typeof callback !== 'function' || typeof setIntervalFn !== 'function') {
    return null;
  }

  try {
    return setIntervalFn(callback, delay);
  } catch (error) {
    return null;
  }
};

export const clearSafeInterval = (
  interval = null,
  clearIntervalFn = getDefaultClearInterval()
) => {
  if (!interval || typeof clearIntervalFn !== 'function') {
    return false;
  }

  try {
    clearIntervalFn(interval);
    return true;
  } catch (error) {
    return false;
  }
};

export const scheduleSafeAnimationFrame = (
  callback,
  requestAnimationFrameFn = getDefaultRequestAnimationFrame()
) => {
  if (
    typeof callback !== 'function' ||
    typeof requestAnimationFrameFn !== 'function'
  ) {
    return null;
  }

  try {
    return requestAnimationFrameFn(callback);
  } catch (error) {
    return null;
  }
};

export const clearSafeAnimationFrame = (
  frame = null,
  cancelAnimationFrameFn = getDefaultCancelAnimationFrame()
) => {
  if (!frame || typeof cancelAnimationFrameFn !== 'function') {
    return false;
  }

  try {
    cancelAnimationFrameFn(frame);
    return true;
  } catch (error) {
    return false;
  }
};
